import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  titles: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Ativar notificações WhatsApp',
    [ONBOARDING_GUIDE_STEPS.Voice]: 'Chamadas automáticas sobre pedidos pendentes',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Horário de funcionamento',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Localização',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Identidade do restaurante',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Tempo de takeaway',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Tempo de entrega',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Credenciais de pessoal',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Importar menu',
    [ONBOARDING_GUIDE_STEPS.Favourites]: 'Favoritos',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Itens esgotados',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Códigos promocionais',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Galeria',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]: 'Adicionar logótipo e cor principal do restaurante',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Encomendar flyers',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Criar loja',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Ativar pedidos em direto',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Ativar Google Business',
  },
  descriptions: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Verificar se o proprietário/contacto tem WhatsApp',
    [ONBOARDING_GUIDE_STEPS.Voice]:
      'Verificar se o número do restaurante está correto para receber chamadas automáticas e não perder pedidos',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Configurar os horários de funcionamento do restaurante',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Configurar a localização do restaurante',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Defina o tipo de restaurante e as cozinhas apresentadas na loja',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Configurar as definições de tempo de takeaway',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Configurar definições de tempo de entrega',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Configurar credenciais do pessoal',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Importar menu de fornecedor externo',
    [ONBOARDING_GUIDE_STEPS.Favourites]:
      'Marcar 4 itens como favoritos. Perguntar ao restaurante quais os 4 pratos mais populares',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Configurar comportamento de itens esgotados',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Configurar códigos promocionais',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Atualizar galeria',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]:
      'Obter o logótipo do restaurante ou da página do restaurante no Lieferando. Guardar o logótipo a partir daí. Escolher a cor mais presente no logótipo do restaurante',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Editar design do flyer e criar encomenda',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Criar loja e editar o website se necessário',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Ativar encomendas em direto («!apenas na data de lançamento!»)',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Ligar conta Google Business',
  },
  buttons: {
    mark_as_complete: 'Marcar como concluído',
  },
  toasts: {
    failed_to_save_changes: 'Falha ao guardar alterações',
  },
};
